import { render } from "./TrackNotesPanel.vue?vue&type=template&id=57c44e3e&scoped=true"
import script from "./TrackNotesPanel.vue?vue&type=script&lang=js"
export * from "./TrackNotesPanel.vue?vue&type=script&lang=js"

import "./TrackNotesPanel.vue?vue&type=style&index=0&id=57c44e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c44e3e"]])

export default __exports__